import React from 'react';
import styled from 'styled-components';
import { blue100, spacer4, spacer8, white } from '@spotify-internal/encore-web';
import { purify } from '../../utils/helpers';

export type LozengePropTypes = {
  text: string;
  color?: string;
  backgroundColor?: string;
  borderValues?: {
    color: string;
    width: number;
  };
};

function LozengeComponent(props: LozengePropTypes) {
  const { text, ...rest } = props;

  return (
    <li {...rest}>
      <span dangerouslySetInnerHTML={{ __html: purify(text) }} />
    </li>
  );
}

const Lozenge = styled(LozengeComponent)`
  border-radius: 4px;
  font-size: 14px;
  padding: ${spacer4} ${spacer8};
  display: inline-block;
  font-weight: 900;
  margin: 0 ${spacer4} 10px 0;
  margin-block-start: 0;
  margin-block-end: 10px;
  color: ${({ color }) => color ?? `${white}`};
  background-color: ${({ backgroundColor }) => backgroundColor ?? `${blue100}`};

  :last-child {
    margin-right: 0;
  }

  ${({ borderValues }) =>
    borderValues?.width && borderValues.color
      ? `border: ${borderValues.width}px solid ${borderValues.color};`
      : ''}
`;

export default Lozenge;
